module.exports = __webpack_public_path__ + "img/windmill.aa491588.png";